import moment from 'moment';

const validTypes = ['activities', 'steps', 'tasks'];

/**
 * Takes an array of calendar items (activities, steps, or tasks) and groups them
 * by day into a big 'ole object containing arrays keyed by the ISO date of
 * the calendar item (i.e. '2016-04-01': ['1-todos', '2-todos', ...])
 * @param  {array} items        Array of calendar item model objects
 * @return {object}             Object keyed by ISO date values of the grouped items
 */
export function groupCalendarItemsByDay(items) {
    const calendarItemsByDay = {};

    items.forEach((item) => {
        if (item.type && validTypes.includes(item.type)) {
            const timestamp = item.type === 'activities' ? item.startTime : item.dueTime;

            const formattedDate = moment.unix(timestamp).format('YYYY-MM-DD');

            if (calendarItemsByDay[formattedDate]) {
                calendarItemsByDay[formattedDate].push(item);
            } else {
                calendarItemsByDay[formattedDate] = [item];
            }
        }
    });

    return calendarItemsByDay;
}
